


































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import TopNavigationComponent from "@/components/App/Modules/GMS/Workspace/Components/TopNavigation.vue";
import LogframeworkComponent from "./Components/Logframework.vue";
import ApplicationForm from "./Components/ApplicationForm.vue";
import BasicInfoForm from "./Components/BasicInfo.vue";
import GenericImportForm from "./Components/GenericImportForm.vue";
import ImportSummary from "./Components/ImportSummary.vue";
import series from "./Components/Budget.vue";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { MigrationImport } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";

const namespace: string = "migration";

@Component({
  components: {
    TopNavigationComponent,
    ApplicationForm,
    BasicInfoForm,
    VJsonschemaForm,
    GenericImportForm,
    series,
    ImportSummary,
    LogframeworkComponent,
  },
})
export default class MigrationImportComponent extends Vue {
  @State(namespace) migration!: MigrationImport;
  @Action("updateMigrationData", { namespace }) update: any;
  @Action("getMigrationData", { namespace }) getData: any;
  @Action("saveMigrationData", { namespace }) saveData: any;
  isDirty: boolean = false;
  disableSave = _app.migrationsaveStatus;
  statusId = 0;
  formKey: number = 1;  

  mounted() {}

  enableButton() {
    const self = this;
    //@ts-ignore
    if (!self.disableSave.includes(self.statusId)) {
      // for applicants
      return true;
    }
    return false;
  }

  get schema() {
    return this.migration.Schema;
  }

  get grantSchema() {
    return this.migration.GrantSchema;
  }

  get subSchema() {
    if (this.schema && this.schema.properties) {
      return this.schema.properties[this.migration.SelectedTopMenu];
    } else {
      return {};
    }
  }

  get users() {
    return this.migration.Users;
  }

  get tags() {
    return this.migration.Tags;
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any, previousRoute) {       
    if (changedRoute && changedRoute.name === "Migration") {
      this.getData(parseInt(this.$route.params.id)).then((data) => {      
        this.migration.SelectedTopMenu = Object.keys(
          this.migration.Schema.properties
        )[0];
        this.migration.SelectedSubMenu = Object.keys(
          this.migration.Schema.properties[this.migration.SelectedTopMenu]
            .properties
        )[0];
        this.statusId = parseInt(this.$route.params.statusId);        
        this.formKey += 1;
      });
    }
  }

  submenuChanged(menu) {
    this.saveDirty(() => {
      this.migration.SelectedSubMenu = menu.subMenu;
    });
  }

  subMenuChanged(menu) {
    this.saveDirty(() => {
      this.migration.SelectedSubMenu = menu;
    });
  }

  topMenuChanged(key) {
    this.saveDirty(() => {
      this.migration.SelectedTopMenu = key;
      this.migration.SelectedSubMenu = Object.keys(
        this.migration.Schema.properties[key].properties
      )[0];
    });
  }

  save() {
    this.saveDirty(() => {});
  }

  backToList() {
    this.$router.push({
      name: "Migrations",
    });
  }

  setDirtyFlag(flag) {
    if (!this.disableSave.includes(this.statusId)) {
      this.isDirty = flag;
    }
  }

  setFromBudgetValues(obj) {
    const {
      totalProjectBudget,
      sosFundReq,
      directEligbleCost,
      totalBudget,
      sumTotalBudget,
      totMatchingFund,
    } = obj;

    // for RAG project
    if (
      totalProjectBudget &&
      totalProjectBudget.Total &&
      totalProjectBudget.Total.value
    ) {
      this.migration.ImportData["projectBudget"] =
        totalProjectBudget.Total.value;
    }
    // for TSG tiger project
    if (totalBudget && totalBudget.Total && totalBudget.Total.value) {
      this.migration.ImportData["projectBudget"] =
        totalBudget.Total.value + (totalBudget.matchFunding || 0);
      this.migration.ImportData["projectRequestedAmount"] =
        totalBudget.Total.value;
    }
    // for TSG sos project
    if (sosFundReq && sosFundReq.Total && sosFundReq.Total.value) {
      this.migration.ImportData["projectRequestedAmount"] =
        sosFundReq.Total.value;
    }
    if (
      this.migration.ImportData["projectBudget"] &&
      this.migration.ImportData["projectRequestedAmount"]
    ) {
      this.migration.ImportData["amountOfMatchingFund"] =
        this.migration.ImportData["projectBudget"] -
        this.migration.ImportData["projectRequestedAmount"];
    }
    // other sos project
    if (sumTotalBudget && sumTotalBudget.Total && sumTotalBudget.Total.value) {
      this.migration.ImportData["projectBudget"] = sumTotalBudget.Total.value;
    }
    if (
      totMatchingFund &&
      totMatchingFund.Total &&
      totMatchingFund.Total.value
    ) {
      this.migration.ImportData["amountOfMatchingFund"] =
        totMatchingFund.Total.value;

      if (
        this.migration.ImportData["amountOfMatchingFund"] &&
        this.migration.ImportData["projectBudget"]
      ) {
        this.migration.ImportData["projectRequestedAmount"] =
          (this.migration.ImportData["projectBudget"] || 0) -
          (this.migration.ImportData["amountOfMatchingFund"] || 0);
      }
    }
  }

  /*** save if form is dirty */
  saveDirty(callback: any) {
    if (this.isDirty) {
      // save the data if form is dirty
      this.isDirty = false;
      this.saveData(this.migration).then((success) => {
        if (success) {
          callback();
        }
      });
    } else {
      callback();
    }
  }
}
